import React from 'react'

import Link from 'src/components/link/index'
import Date from 'src/components/datetime/date'

import * as styles from './item.module.scss'


const Item = ({ show, node }) => {

    const url = node.custom.type === 'outer' ? node.custom.url : `/article/${node.custom.slug}/`

    return (
        <Link className={styles.item} to={url} data-show={show}>
            <div className={styles.head}>
                <div className={styles.tag}>{node.tags.nodes[0].name}</div>
                <Date dateText={node.custom.datetime} />
            </div>
            {node.custom.title && <div className={styles.title}>{node.custom.title}</div>}
            {node.custom.lead && <div className={styles.lead}>{node.custom.lead}</div>}
        </Link>
    )
}

export default Item